import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { SubscriptionForm } from '../SubscriptionForm/SubscriptionForm';
import { render, html } from 'lit-html';

import './DropdownButton.scss';

@Component
export class DropdownButton extends ThemeComponent {
    @Ref() navButton!: HTMLButtonElement;
    @Ref() optionButton!: HTMLButtonElement[];
    @Ref({ required: false }) selectedOptionMessage!: HTMLSpanElement;
    @Ref({ required: false }) selectedOptionText!: HTMLSpanElement;
    @Ref({ required: false }) selectedOptionBadgeText!: HTMLSpanElement;
    @Ref({ required: false }) button!: HTMLButtonElement;

    private childClickedEvent!: Event;
    private subscriptionForm: SubscriptionForm|null = null;
    private selectedButton: HTMLButtonElement|null|undefined = null;

    private _onDropDownSelect = new SimpleEvent<string>();
    public get onDropDownSelect() {
        return this._onDropDownSelect.asEvent();
    }

    constructor() {
        super();
        this.childClickedEvent = new Event('dropdown-button-click');
    }

    init() {

        this.selectedButton = this.optionButton.find((button) => button.classList.contains('selected'));

        this.$listen(this, 'mouseover', (event) => {
            const targetElement = event.target as HTMLElement;
            // If this dropdown button was hovered, open it
            // otherwise, close it
            if (targetElement.closest('.dropdown-button') == this &&
                !this.classList.contains('dropdown-button--active')) {
                this.openDropdown();
            }
        });

        this.$listen(this, 'mouseout', (event) => {
            // If this dropdown button was hovered, open it
            // otherwise, close it
            this.closeDropdown();
        });

        // Listen for click events on the window
        this.$listen(window, 'click', (event) => {
            // If the target element is within a dropdown wrapper
            // select the clicked element and bail
            const targetElement = event.target as HTMLElement;
            const dropdown = targetElement.closest('dropdown-button');
            const dropdownWrapper = targetElement.closest('.dropdown-button__dropdown-wrapper');

            if (dropdown == this && dropdownWrapper) {
                if (targetElement.closest('.dropdown__child-button')) {

                    const clickedButton = targetElement.closest('.dropdown__child-button');
                    const subscriptionForm =
                    document.querySelector('subscription-form') as SubscriptionForm;

                    // if (subscriptionForm && clickedButton) {
                    //     const frequency = clickedButton.getAttribute('data-linked-input');
                    //     if (frequency) {
                    //         subscriptionForm.updateSelectedFrequency(frequency);
                    //     }
                    // }

                    if (clickedButton) {
                        this.updateOption(clickedButton.id);
                    }


                }

            }

            // If this dropdown button was clicked, open it
            // otherwise, close it
            if (targetElement.closest('.dropdown-button') == this &&
                !this.classList.contains('dropdown-button--active')) {
                this.openDropdown();
            } else {
                this.closeDropdown();
            }

        });
    }

    openDropdown() {
        this.classList.add('dropdown-button--active');
        this.dispatchEvent(new Event('DropdownActive', {
            bubbles: true
        }));
    }

    closeDropdown() {
        this.classList.remove('dropdown-button--active');
        this.dispatchEvent(new Event('DropdownInactive', {
            bubbles: true
        }));
    }

    public updateOption(id: string) {

        this.selectedButton = this.optionButton.find((button) => button.id == id);

        if (!this.selectedButton) {
            return;
        }

        // Switch the selected button to the one that was clicked
        for (const button of this.optionButton) {
            button.classList.remove('button--selection-active');
        }
        this.selectedButton.classList.add('button--selection-active');

        // Switch the content in the dropdown trigger element to
        // the content of the selected option
        if (this.selectedOptionMessage) {
            render(html`${this.selectedButton.getAttribute('data-option-message')}`, this.selectedOptionMessage);
        }

        if (this.selectedOptionText) {
            render(html`${this.selectedButton.getAttribute('data-option-text')}`, this.selectedOptionText);
        }

        if (this.selectedOptionBadgeText) {
            render(html`${this.selectedButton.getAttribute('data-option-badge-text')}`, this.selectedOptionBadgeText);
        }

        this._onDropDownSelect.dispatch(id);

    }
}
